import { DEMO_CONNECTION_INDEX } from 'portal-sdk';
import { UseQueryOptions } from 'react-query';

import {
  PortalConnection,
  usePortalConnectionByIndex,
} from 'bones/utils/portal/usePortalConnectionByIndex';

/**
 * Returns the "demo" portal connection which isn't included in lists
 */
export const usePortalDemoConnection = (
  options?: UseQueryOptions<PortalConnection | null>
) => usePortalConnectionByIndex(DEMO_CONNECTION_INDEX, options);
